// extracted by mini-css-extract-plugin
module.exports = {"shop":"Shop_shop__1oFPY","details":"Shop_details__2LD3q","name":"Shop_name__3bul8","address":"Shop_address__3dZoJ","chevron":"Shop_chevron__3ilH4"};